import { MFLink } from '@medifind/shared-basic-components';
import { Skeleton } from '@medifind/shared-basic-components';
import styles from './CardAffiliation.module.scss';

const CardAffiliation = ({ isDataLoaded, link, display, analyticsLinkType, style }) => {
  if (!isDataLoaded) {
    return <Skeleton />;
  }
  if (!display) {
    return null;
  }
  return (
    <h4 className={styles['affiliation']} style={style}>
      {link ? (
        <MFLink analyticsLinkType={analyticsLinkType} to={link} target="blank" className={styles['org-link']}>
          {display}
        </MFLink>
      ) : (
        display
      )}
    </h4>
  );
};

export { CardAffiliation as default, CardAffiliation };
